function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M9.5 21v-6h5v6m5.5 0v-9.051M4 21v-9.051M22 21H2M7 9.5a2.5 2.5 0 01-5 0V8.33a1 1 0 01.093-.42l1.742-3.752A2 2 0 015.649 3H18.35a2 2 0 011.814 1.158l1.742 3.752a1 1 0 01.093.42V9.5a2.5 2.5 0 01-5 0"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M17 9.5a2.5 2.5 0 01-5 0m0 0a2.5 2.5 0 01-5 0"
}));